/**
 * js/ts-phone-track.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Track tous les clics sur les liens tel: (click-to-call) via :
 *  - Meta Pixel (browser)
 *  - Meta CAPI (serveur), avec déduplication par event_id
 *
 * keepalive: true — garantit que la requête fetch arrive au serveur même si
 * le navigateur quitte la page pour ouvrir le téléphone immédiatement après.
 * ─────────────────────────────────────────────────────────────────────────────
 */
document.addEventListener("DOMContentLoaded", function () {
  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp(
        "(?:^|; )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)",
      ),
    );
    return match ? decodeURIComponent(match[1]) : "";
  }

  function generateEventId() {
    return "phone_" + Date.now() + "_" + Math.random().toString(36).slice(2, 9);
  }

  document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
    link.addEventListener("click", function () {
      const eventId = generateEventId();
      const fbc = getCookie("_fbc");
      const fbp = getCookie("_fbp");

      // ── Browser Pixel ────────────────────────────────────────────────────
      if (typeof fbq === "function") {
        fbq(
          "track",
          "Contact",
          { content_name: "phone-click" },
          { eventID: eventId },
        );
      }

      // ── Google Ads / GA4 ─────────────────────────────────────────────────
      if (typeof gtag === "function") {
        gtag("event", "contact", {
          event_category: "clic-telephone",
          event_label: "tel-5816883773",
        });
      }

      // ── Serveur CAPI (keepalive = survit à la navigation vers l'app tél.) ─
      fetch("/include/capi-event.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({
          event: "Contact",
          event_id: eventId,
          fbc: fbc,
          fbp: fbp,
          url: window.location.href,
        }),
      }).catch(function () {});
    });
  });
});
